"use client";

import { c as _c } from "react/compiler-runtime";
import ResponsiveModal from "@/components/custom/ResponsiveModal";
import { useGuide } from "@/hooks/useGuide";
import { openSupport } from "@/lib/support";
import { useSupportStore } from "@/stores/supportStore";
import { IconArrowLeft, IconNewspaper2, IconSupport } from "@central-icons-react/square-outlined-radius-0-stroke-1.5";
import { IconBookOpenOutline18, IconCheckOutline18 } from "nucleo-ui-outline-18";
export function SupportModal() {
  const $ = _c(13);
  const open = useSupportStore(_temp);
  const view = useSupportStore(_temp2);
  const setView = useSupportStore(_temp3);
  const close = useSupportStore(_temp4);
  const {
    startGuide,
    availableGuides,
    hasCompleted
  } = useGuide();
  let t0;
  if ($[0] !== close) {
    t0 = nextOpen => {
      if (!nextOpen) {
        close();
      }
    };
    $[0] = close;
    $[1] = t0;
  } else {
    t0 = $[1];
  }
  let t1;
  if ($[2] !== availableGuides || $[3] !== close || $[4] !== hasCompleted || $[5] !== setView || $[6] !== startGuide || $[7] !== view) {
    t1 = view === "menu" ? <div><h3 className="text-ds-text-primary mb-1 text-lg font-semibold">Support</h3><p className="body-sm mb-4">Get help, explore guides, or share feedback</p><div className="flex flex-col gap-1"><button type="button" onClick={() => setView("guides")} className="text-ds-text-secondary dark:hover:bg-ds-neutral-800 hover:bg-ds-surface-hover flex w-full items-center gap-3 rounded-lg px-3 py-3 text-left text-sm transition-colors"><IconNewspaper2 className="text-ds-text-disabled h-5 w-5 flex-shrink-0" /><div className="flex-1"><p className="font-medium">Guides</p><p className="label-xs">Interactive walkthroughs</p></div></button><button type="button" onClick={() => {
          close();
          openSupport();
        }} className="text-ds-text-secondary dark:hover:bg-ds-neutral-800 hover:bg-ds-surface-hover flex w-full items-center gap-3 rounded-lg px-3 py-3 text-left text-sm transition-colors"><IconSupport className="text-ds-text-disabled h-5 w-5 flex-shrink-0" /><div className="flex-1"><p className="font-medium">Contact Support</p><p className="label-xs">Chat with our team</p></div></button></div></div> : <div><button type="button" onClick={() => setView("menu")} className="text-ds-text-muted hover:text-ds-text-primary mb-3 flex items-center gap-1.5 text-sm transition-colors dark:hover:text-white"><IconArrowLeft className="h-4 w-4" />Back</button><h3 className="text-ds-text-primary mb-1 text-lg font-semibold">Guides</h3><p className="body-sm mb-4">Interactive walkthroughs to help you get started</p><div className="flex flex-col gap-1">{availableGuides.map(guide => {
          const isCompleted = hasCompleted(guide.id);
          return <button key={guide.id} type="button" onClick={() => {
            close();
            startGuide(guide.id);
          }} className="text-ds-text-secondary dark:hover:bg-ds-neutral-800 hover:bg-ds-surface-hover flex w-full items-center gap-3 rounded-lg px-3 py-3 text-left text-sm transition-colors"><IconBookOpenOutline18 className="text-ds-text-disabled h-4 w-4 flex-shrink-0" /><span className="flex-1">{guide.name}</span>{isCompleted && <IconCheckOutline18 className="h-4 w-4 text-green-500" />}</button>;
        })}{availableGuides.length === 0 ? <div className="body-sm py-4 text-center">No guides available</div> : null}</div></div>;
    $[2] = availableGuides;
    $[3] = close;
    $[4] = hasCompleted;
    $[5] = setView;
    $[6] = startGuide;
    $[7] = view;
    $[8] = t1;
  } else {
    t1 = $[8];
  }
  let t2;
  if ($[9] !== open || $[10] !== t0 || $[11] !== t1) {
    t2 = <ResponsiveModal open={open} onOpenChange={t0} title="Support">{t1}</ResponsiveModal>;
    $[9] = open;
    $[10] = t0;
    $[11] = t1;
    $[12] = t2;
  } else {
    t2 = $[12];
  }
  return t2;
}
function _temp4(s_2) {
  return s_2.close;
}
function _temp3(s_1) {
  return s_1.setView;
}
function _temp2(s_0) {
  return s_0.view;
}
function _temp(s) {
  return s.open;
}